
interface RestoreConfig{
    restore:{
        transformer: (fields:{[key:string]:any}) => {[key:string]:any}
        fieldNames:{ 
            quoteNumber:string,
            email:string
        }
    },
    [others: string]: any
}


export default function(config:RestoreConfig){

    const initialState = {
        transformer: config.restore.transformer,
        fieldNames: config.restore.fieldNames
    }


    return function(state = initialState, action){

        switch(action.type){
            default: return state
        }

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/restore/restore-reducer.ts